"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCalibration = void 0;
const base_1 = require("./base");
class IkeObjectCalibration extends base_1.IkeRestObject {
    constructor() {
        super(...arguments);
        this.className = 'Calibration';
        this.actionName = 'calibration';
    }
}
exports.IkeObjectCalibration = IkeObjectCalibration;
//# sourceMappingURL=calibration.object.js.map